import { render, staticRenderFns } from "./AgentLandingHero.vue?vue&type=template&id=80445e20&scoped=true&"
import script from "./AgentLandingHero.vue?vue&type=script&lang=js&"
export * from "./AgentLandingHero.vue?vue&type=script&lang=js&"
import style0 from "./AgentLandingHero.vue?vue&type=style&index=0&id=80445e20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80445e20",
  null
  
)

export default component.exports